import { useEffect, useState } from "react";
import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";

import { showBathrooms } from "../../../Utils/Functions";
import { useFilters } from "../Filters.hook";

const FRAGMENT_BATHROOMS_OPTIONS = new FragmentDefiner(
	"Filter",
	`
		  id
		  name
		  options
	  `
);

export const FRAGMENT_BATHROOMS = new FragmentDefiner(
	"Filters",
	`
		  bathrooms {
		  ${FRAGMENT_BATHROOMS_OPTIONS.query()}
		  }
	  `
);

export const useBathrooms =  () => {
	const { filters } = useFilters();
	const [value, setValue] = useState(filters?.bathrooms);
	const [exactMode, setExactMode] = useState(filters?.bathroomsExactMode);

	const show = showBathrooms(filters?.property_type_id, filters?.operation_type_id);
	const type = "multiple";

	useEffect(() => {
		setValue(filters?.bathrooms)
	}, [filters?.bathrooms])

	useEffect(() => {
		setExactMode(filters?.bathroomsExactMode)
	}, [filters?.bathroomsExactMode])

	return {
		show,
		data: {
			selectedValue: value,
			setSelectedValue: setValue,
			exactMode,
			type: type,
		}
	};
};
